import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    loading: {
      height: theme.spacing(4),
    },
    root: {
      display: 'flex',
    },
    editDivider: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
  };
};
